import {Injectable} from '@angular/core';
import {HttpClient } from '@angular/common/http';
import {Observable} from "rxjs";
import {QueueRoot} from "./queueData";
import {UrlBuilder} from "../url-builder/url.builder";


@Injectable({
  providedIn: 'root'
})

export class QueueDataService {

  private uiUrl: string = "";
  url: UrlBuilder;

  constructor(private http: HttpClient) {
    this.url = new UrlBuilder();
  }
  GetData(): Observable<QueueRoot> {
    this.uiUrl = this.url.GetQueueUrl();
    console.log('FILE: ' + this.uiUrl);
    return this.http.get<QueueRoot>(this.uiUrl);
  }
}



